module.exports = __webpack_public_path__ + "img/mollusques.50f7df8e.svg";